import { BasicStyledComponent, DSRootCategoryHero } from 'shared-definitions/types'
import styles from './RootCategoryHero.module.css'
import clsx from 'clsx'
import PostHeroMain from 'shared-components/posts/PostsHeroMain'
import PostRow from 'shared-components/posts/PostRow'

type RootCategoryHeroProps = DSRootCategoryHero &
  BasicStyledComponent & {
    reversed?: boolean
  }

const RootCategoryHero: React.VFC<RootCategoryHeroProps> = ({
  reversed,
  main,
  side,
  className,
}) => {
  if (!main) {
    return null
  }
  return (
    <div
      className={clsx(styles.container, className, {
        [styles.reversed]: reversed,
      })}
    >
      <PostHeroMain post={main} className={styles.main} />
      {side.map((item, index) => (
        <PostRow key={index} post={item} className={styles.side} />
      ))}
    </div>
  )
}

export default RootCategoryHero
